import {
  ImageList,
  ImageListItem,
  Stack,
  useMediaQuery,
  useTheme,
  Pagination,
  Box,
} from "@mui/material";
import React from "react";
import { colors } from "../../assets";
import { ParagraphText, TitleText } from "../atoms";
import { BasicCard, ThumbnailCard } from "../molecules";

export const InsightList = ({
  categories,
  selectedCategory,
  insights,
  style,
  categoryPages,
  categoryTotalPages,
  onPageChange,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const filteredCategories = categories?.filter((category) =>
    category?.title?.includes(selectedCategory)
  );

  if (!(filteredCategories?.length > 0)) {
    return (
      <ParagraphText style={{ fontStyle: "italic", color: colors.gray3 }}>
        No data found.
      </ParagraphText>
    );
  }

  return (
    <Stack spacing="48px" style={{ overflowX: "hidden", ...style }}>
      {filteredCategories?.map((category) => {
        const filteredInsights = insights?.filter(
          (item) =>
            item?.categories?.data[0]?.attributes?.title === category?.title
        );

        return (
          <Stack
            key={category?.order_number}
            direction={!isMobile ? "row" : "column"}
            gap="24px"
          >
            {/* RESEARCH CATEGORY TITLE CARD */}
            {!isMobile ? (
              <BasicCard
                title={category?.title}
                subtitle={category?.subtitle || category?.description}
                imageSrc={category?.image_url?.data?.attributes?.url}
                titleFontSize="32px"
                alignItems="start"
                style={{ width: "200px", height: "300px", flex: "none" }}
              />
            ) : (
              <TitleText>{category?.title}</TitleText>
            )}

            {/* RESEARCH LIST */}
            <Stack spacing={2}>
              {!(filteredInsights?.length > 0) ? (
                <ParagraphText
                  style={{ fontStyle: "italic", color: colors.gray3 }}
                >
                  No data found.
                </ParagraphText>
              ) : (
                <>
                  <ImageList
                    gap={12}
                    sx={{ gridAutoFlow: "column", margin: 0 }}
                  >
                    {filteredInsights?.map((item, index) => (
                      <ImageListItem
                        key={index}
                        style={{ marginBottom: "16px" }}
                      >
                        <ThumbnailCard
                          title={item?.title}
                          style={{ width: "180px" }}
                          imgSrc={item?.thumbnail_url?.data?.attributes?.url}
                          href={`/insight/${item?.id}`}
                          onClick={() =>
                            window.scrollTo({ top: 0, behavior: "smooth" })
                          }
                        />
                      </ImageListItem>
                    ))}
                  </ImageList>
                  {categoryTotalPages[category.title] > 1 && (
                    <Box
                      display="flex"
                      justifyContent="flex-start"
                      mt={2}
                      sx={{
                        width: "100%",
                        maxWidth: "calc(180px * 4 + 12px * 3)",
                        "& .MuiPagination-root": {
                          "& .MuiPaginationItem-root": {
                            color: colors.gray3,
                            border: `1px solid ${colors.gray3}`,
                            margin: "0 4px",
                            minWidth: "32px",
                            height: "32px",
                            borderRadius: "4px",
                            "&.Mui-selected": {
                              backgroundColor: colors.primary,
                              color: "white",
                              border: "none",
                              "&:hover": {
                                backgroundColor: colors.primary,
                              },
                            },
                            "&:hover": {
                              backgroundColor: "rgba(255, 255, 255, 0.08)",
                            },
                          },
                          "& .MuiPaginationItem-ellipsis": {
                            color: colors.gray3,
                          },
                          "& .MuiPaginationItem-firstLast, & .MuiPaginationItem-previousNext":
                            {
                              color: colors.gray3,
                              border: `1px solid ${colors.gray3}`,
                              "&:hover": {
                                backgroundColor: "rgba(255, 255, 255, 0.08)",
                              },
                            },
                        },
                      }}
                    >
                      <Pagination
                        count={categoryTotalPages[category.title]}
                        page={categoryPages[category.title]}
                        onChange={(event, value) =>
                          onPageChange(category.title, value)
                        }
                        color="primary"
                        size={isMobile ? "small" : "medium"}
                        siblingCount={0}
                        boundaryCount={1}
                      />
                    </Box>
                  )}
                </>
              )}
            </Stack>
          </Stack>
        );
      })}
    </Stack>
  );
};
